import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MetabaseReportService } from '../services/metabase-report.service';

@Component({
  selector: 'app-home',
  imports: [RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  private readonly metabaseReports = inject(MetabaseReportService);

  readonly projectInventoryReportUrl = this.metabaseReports.projectInventoryUrl();
}
